(function(){
'use strict';
var T=window.theme||{},doc=document,body=doc.body;
var $=function(s,r){return (r||doc).querySelector(s)},$$=function(s,r){return Array.prototype.slice.call((r||doc).querySelectorAll(s))};
var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion:reduce)').matches;
function toast(m){var t=$('[data-toast]');if(!t)return;t.textContent=m;t.classList.add('on');clearTimeout(toast.t);toast.t=setTimeout(function(){t.classList.remove('on')},2200)}
function lock(){body.classList.toggle('no-scroll',body.classList.contains('mn-open')||body.classList.contains('cart-open'))}

/* header: shadow + spinning logo */
var last=window.scrollY,rot=0,tick=false,st;
window.addEventListener('scroll',function(){if(tick)return;tick=true;requestAnimationFrame(function(){
  var y=window.scrollY,d=y-last;last=y;var h=$('[data-header]');if(h)h.classList.toggle('sc',y>10);
  if(T.rotateLogo&&!reduce){var m=$('.hd__logo .mark');if(m){rot+=d*.45;m.style.setProperty('--rot',rot+'deg');m.style.setProperty('--sc',1+Math.min(Math.abs(d),60)/220);clearTimeout(st);st=setTimeout(function(){m.style.setProperty('--sc',1)},160)}}
  tick=false})},{passive:true});

/* menus */
function closeDD(){$$('[data-dd].o').forEach(function(d){d.classList.remove('o');var b=$('.dd__btn',d);if(b)b.setAttribute('aria-expanded','false')})}
function openMenu(o){body.classList.toggle('mn-open',o);lock()}
function openCart(o){var d=$('#CartDrawer');if(!d)return;body.classList.toggle('cart-open',o);d.setAttribute('aria-hidden',o?'false':'true');lock()}
doc.addEventListener('click',function(e){
  var t=e.target,b;
  if((b=t.closest('.dd__btn'))){var dd=b.closest('[data-dd]'),was=dd.classList.contains('o');closeDD();if(!was){dd.classList.add('o');b.setAttribute('aria-expanded','true')}return}
  if(!t.closest('[data-dd]'))closeDD();
  if(t.closest('[data-menu-open]'))return openMenu(true);
  if(t.closest('[data-menu-close]'))return openMenu(false);
  if(t.closest('.mn a'))openMenu(false);
  if(t.closest('[data-drawer-close]'))return openCart(false);
  if((b=t.closest('[data-cart-open]'))&&T.cartType!=='page'&&$('#CartDrawer')){e.preventDefault();return openCart(true)}
  if((b=t.closest('[data-row-prev],[data-row-next]'))){var s=b.closest('section'),r=s&&$('.row',s);if(r)r.scrollBy({left:(b.hasAttribute('data-row-next')?1:-1)*(T.rtl?-1:1)*r.clientWidth*.9,behavior:'smooth'});return}
  if((b=t.closest('[data-qty-minus],[data-qty-plus]'))){var i=$('[data-qty]',b.parentNode),v=parseInt(i.value,10)||1;i.value=Math.max(1,v+(b.hasAttribute('data-qty-plus')?1:-1));return}
  if((b=t.closest('[data-thumb]')))return gal(b.closest('[data-product]'),+b.getAttribute('data-thumb'));
  if((b=t.closest('[data-gal-prev],[data-gal-next]'))){var g=$('[data-gal]',b.closest('[data-product]'));g.scrollBy({left:(b.hasAttribute('data-gal-next')?1:-1)*g.clientWidth,behavior:'smooth'});return}
  if((b=t.closest('[data-qty-change]')))return changeQty(b.closest('.ln'),parseInt(b.getAttribute('data-qty-change'),10));
  if((b=t.closest('[data-remove]')))return setQty(b.closest('.ln'),0);
});
doc.addEventListener('keydown',function(e){if(e.key==='Escape'){closeDD();openMenu(false);openCart(false)}});

/* gallery */
function gal(root,i){var g=$('[data-gal]',root);if(!g)return;var s=g.children[i];if(s)g.scrollTo({left:s.offsetLeft-g.offsetLeft,behavior:reduce?'auto':'smooth'})}
function galSync(g){var root=g.closest('[data-product]'),i=Math.round(Math.abs(g.scrollLeft)/g.clientWidth);$$('[data-thumb]',root).forEach(function(b,k){b.classList.toggle('on',k===i)})}
doc.addEventListener('scroll',function(e){if(e.target&&e.target.matches&&e.target.matches('[data-gal]'))galSync(e.target)},true);
function galToMedia(root,id){var g=$('[data-gal]',root);if(!g||!id)return;var s=$('[data-media-id="'+id+'"]',g);if(s)g.scrollTo({left:s.offsetLeft-g.offsetLeft,behavior:'auto'})}

/* variants */
doc.addEventListener('change',function(e){
  var t=e.target;
  if(t.matches('[data-opt]'))return variantChange(t.closest('[data-product]'));
  if(t.matches('[data-loc-submit]'))return t.form.submit();
  if(t.closest('[data-filters]')&&(t.matches('input[type=checkbox],[data-sort]')))return t.form.submit();
});
function variantChange(root){
  var sc=$('[data-variants]',root);if(!sc)return;var vs=JSON.parse(sc.textContent),sel=[];
  $$('[data-option-index]',root).forEach(function(f){var c=$('[data-opt]:checked',f);sel.push(c?c.value:null);var l=$('[data-opt-label]',f);if(l&&c)l.textContent=c.value});
  var v=vs.filter(function(x){return x.options.every(function(o,i){return o===sel[i]})})[0];
  var btn=$('[data-add]',root);
  if(!v){if(btn){btn.disabled=true;btn.textContent=T.strings.unavailable}return}
  var form=doc.getElementById(root.getAttribute('data-form'));if(form){var id=$('[data-variant-id]',form);if(id)id.value=v.id}
  history.replaceState(null,'','?variant='+v.id);
  if(v.featured_media&&v.featured_media.id)galToMedia(root,v.featured_media.id);
  fetch(location.pathname+'?variant='+v.id+'&section_id='+root.getAttribute('data-section'),{credentials:'same-origin'}).then(function(r){return r.text()}).then(function(h){
    var d=new DOMParser().parseFromString(h,'text/html');
    $$('[data-swap]',root).forEach(function(el){var n=$('[data-swap="'+el.getAttribute('data-swap')+'"]',d);if(n)el.innerHTML=n.innerHTML})
  })
}

/* cart */
var queue=Promise.resolve(),timers={};
function refresh(){
  return fetch(T.cartUrl+'?t='+Date.now(),{cache:'no-store',credentials:'same-origin'}).then(function(r){return r.text()}).then(function(h){
    var d=new DOMParser().parseFromString(h,'text/html'),nd=$('#CartDrawer',d),od=$('#CartDrawer');
    if(nd&&od){['[data-cart-body]','[data-cart-foot]'].forEach(function(s){var a=$(s,od),b=$(s,nd);if(a&&b)a.innerHTML=b.innerHTML});od.setAttribute('data-count',nd.getAttribute('data-count'))}
    var nm=$('#MainCart',d),om=$('#MainCart');if(nm&&om)om.innerHTML=nm.innerHTML;
    var c=nd?nd.getAttribute('data-count'):'0';
    $$('[data-cart-count]').forEach(function(el){if(el.textContent!==c){el.textContent=c;el.classList.remove('bump');void el.offsetWidth;el.classList.add('bump')}el.hidden=c==='0'})
  })
}
function post(url,data){return fetch(url,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(data)})}
function changeQty(line,delta){var n=line.querySelector('.qn'),cur=parseInt(n.textContent,10)||0;setQty(line,Math.max(0,cur+delta))}
function setQty(line,q){
  var key=line.getAttribute('data-key'),n=line.querySelector('.qn');
  if(q>0){n.textContent=q;n.classList.remove('pop');void n.offsetWidth;n.classList.add('pop')}else line.classList.add('is-busy');
  clearTimeout(timers[key]);
  timers[key]=setTimeout(function(){queue=queue.then(function(){return post(T.cartChange,{id:key,quantity:q})}).then(refresh).catch(refresh)},q===0?0:220)
}
doc.addEventListener('submit',function(e){
  var f=e.target;if(!f.matches('[data-product-form],[data-quick-add]'))return;
  if(T.cartType==='page')return;
  e.preventDefault();var btn=$('[type=submit]',f);if(btn)btn.disabled=true;
  var fd=new FormData(f);
  fetch(T.cartAdd,{method:'POST',body:fd,headers:{Accept:'application/json'}}).then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j}})}).then(function(res){
    if(!res.ok){toast(res.j.description||res.j.message||'Error');return}
    return refresh().then(function(){if($('#CartDrawer'))openCart(true);else location.href=T.cartUrl})
  }).catch(function(){f.submit()}).then(function(){if(btn)btn.disabled=false})
});

/* recommendations */
function recs(){$$('[data-recs]').forEach(function(el){if(el.getAttribute('data-done')||$('.row',el))return;el.setAttribute('data-done','1');
  fetch(el.getAttribute('data-url')).then(function(r){return r.text()}).then(function(h){var n=$('[data-recs]',new DOMParser().parseFromString(h,'text/html'));if(n&&n.innerHTML.trim()){el.innerHTML=n.innerHTML;reveal()}})})}

/* reveal on scroll */
var io=('IntersectionObserver' in window)?new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.1,rootMargin:'0px 0px -30px'}):null;
function reveal(){if(!T.animations||!io)return;body.classList.add('anim');var i=0;$$('.rv:not([data-o])').forEach(function(e){e.setAttribute('data-o','1');e.style.transitionDelay=(i++%4)*90+'ms';io.observe(e)})}

function init(){reveal();recs();$$('[data-product]').forEach(function(r){var g=$('[data-gal]',r);if(g)galToMedia(r,g.getAttribute('data-active-media'))})}
if(doc.readyState==='loading')doc.addEventListener('DOMContentLoaded',init);else init();
doc.addEventListener('shopify:section:load',init);
window.addEventListener('pageshow',function(e){if(e.persisted)refresh()});
})();
